import { createSlice } from "@reduxjs/toolkit";
import { EntityType, IItem } from "../../../components/boardLayout/types";
import { SelectBoxOption } from "../../../interfaces";

export type CurrentViewType = "board" | "list";

export type SelectedEntityView = {
    [K in EntityType]: CurrentViewType;
}

export type SelectedHorizontalFilter = {
  [K in EntityType]: SelectBoxOption | null;
}

export type ItemsByBoard = {
  [key: string]: IItem[]
}

interface initialStateType {
  selectedView: SelectedEntityView;
  selectedBoard: SelectedHorizontalFilter,
  itemsByBoard?: ItemsByBoard;
  hasMoved: boolean;
}

export const initialBoard = {
  proposal: null,
  product: null,
  project: null,
  quote: null,
  pricing: null,
  taskManager: null,
  document: null,
}

const initialState: initialStateType = {
  selectedView: {
    proposal: "list",
    product: "list",
    project: "list",
    quote: "list",
    pricing: "list",
    taskManager: "list",
    document: "list",
  },
  selectedBoard: initialBoard,
  itemsByBoard: undefined,
  hasMoved: false
};

const boardSlice = createSlice({
  name: "board",
  initialState,
  reducers: {
    setView(state, { payload }: { payload: { key: keyof SelectedEntityView, value: CurrentViewType } }) {
      state.selectedView = { ...state.selectedView, [payload.key]: payload.value  };
    },
    setItemsByBoard(state, { payload }: { payload: { key: string, value: IItem[] } }) {
      state.itemsByBoard = { ...state.itemsByBoard, [payload.key]: payload.value  };
    },
    setHasMoved(state, { payload }: { payload: boolean }) {
      state.hasMoved = payload;
    },
    updateBoardStateByKey(state, { payload }: { payload: { key: keyof initialStateType, value: any, entity?: EntityType  } }) {
      if (payload.entity && state[payload.key] && typeof state[payload.key] === 'object') {
        (state[payload.key] as any)[payload.entity] = payload.value;
      } else {
        state[payload.key] = payload.value;
      }
    },
  },
});

export const { setView, setItemsByBoard, setHasMoved, updateBoardStateByKey } = boardSlice.actions;
export default boardSlice.reducer;
